if (!customElements.get('swiper-slider')) {
  const bounceMediaCarousel = {
    animationName : 'bounceMediaCarousel',
    timeout : 0,
    triggerAnimation: function (){
      const carousels = document.querySelectorAll('.card__media-carousel');

      if(!carousels.length) return;

      let triggeredCard = null;

      for(let card of carousels){
        const rect = card.getBoundingClientRect();

        if(rect.top < 0 || rect.bottom > window.innerHeight && (triggeredCard || !card.swiperContainer)) continue;

        triggeredCard = card.swiperContainer;

        triggeredCard.classList.add('animate');

        break;
      }

      if(!triggeredCard){
        setTimeout(() => bounceMediaCarousel.triggerAnimation(), bounceMediaCarousel.timeout); //In case no card is found, we continue searching for another card
        return;
      }

      triggeredCard.addEventListener('animationend', (e) => bounceMediaCarousel.callbackHandler(e, triggeredCard));
    },
    callbackHandler: function (e, triggeredCard){
      if(e.animationName !== bounceMediaCarousel.animationName) return;

      triggeredCard.classList.remove('animate');
      setTimeout(() => bounceMediaCarousel.triggerAnimation(), bounceMediaCarousel.timeout);
      triggeredCard.removeEventListener('animationend', bounceMediaCarousel.callbackHandler);
    }
  }

  window.SwiperSlider = class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.swiperContainer = this.querySelector('.swiper');
    }

    connectedCallback() {
      this.initSwiper();
      this.initBounceAnimation();
    }

    initSwiper() {
      if (!this.swiperContainer) return;

      /* Standard swiper config */
      const defaultConfig = {
        loop: false,
        slidesPerView: 1.1,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        allowTouchMove: true,
        freeMode: false,
        mousewheel: false,
      };

      const customConfig = this.getCustomConfig();
      const finalConfig = { ...defaultConfig, ...customConfig };

      this.swiper = new Swiper(this.swiperContainer, finalConfig);

      //Loop fix when using navigation arrows
      if(window.innerWidth > 990 && finalConfig.loop && Object.keys(finalConfig.navigation || {}).length > 0){
        const self = this.swiper;

        this.swiper.on('reachEnd', () => {
          this.swiper.navigation.nextEl.addEventListener('click', function handler(e){
            self.slideToLoop(0);
            self.navigation.nextEl.removeEventListener('click', handler);
          });
        });
      }
    }

    getCustomConfig() {
      const customConfig = {};
      if (this.hasAttribute('data-swiper-config')) {
        Object.assign(customConfig, JSON.parse(this.getAttribute('data-swiper-config')));
      }
      return customConfig;
    }

    initBounceAnimation(){
      if(window.innerWidth > 990) return this.swiperContainer.classList.remove('animate');

      if(!this.swiperContainer.classList.contains('animate') && (!this.dataset.timeout || this.dataset.timeout == 0)) return;

      bounceMediaCarousel.timeout = parseInt(this.dataset.timeout) * 60 * 1000;
      this.removeAttribute('data-timeout');
      this.swiperContainer.addEventListener('animationend', (e) => bounceMediaCarousel.callbackHandler(e, this.swiperContainer));
    }
  };
  customElements.define('swiper-slider', SwiperSlider);
}
